/**
 * Libellés de siège relatifs au joueur humain (Sud = position 0 relative).
 */

export function getRelativeSeatLabel(relativeIndex: number, playerCount: number): string {
  if (playerCount === 5) {
    const labels = ['Sud', 'Est', 'Nord-Est', 'Nord-Ouest', 'Ouest'];
    return labels[relativeIndex] ?? `J${relativeIndex + 1}`;
  }
  if (playerCount === 4) {
    const labels = ['Sud', 'Est', 'Nord', 'Ouest'];
    return labels[relativeIndex] ?? `J${relativeIndex + 1}`;
  }
  if (playerCount === 3) {
    const labels = ['Sud', 'Est', 'Ouest'];
    return labels[relativeIndex] ?? `J${relativeIndex + 1}`;
  }
  return `J${relativeIndex + 1}`;
}

/**
 * Nom affiché à la table (live 5p : sièges relatifs pour les bots).
 */
export function formatTablePlayerName(
  pseudo: string,
  absolutePosition: number,
  myPosition: number,
  playerCount: number,
  isLive = false,
): string {
  if (!pseudo) return pseudo;
  const rel = (absolutePosition - myPosition + playerCount) % playerCount;
  if (isLive && playerCount === 5 && absolutePosition !== myPosition) {
    return getRelativeSeatLabel(rel, playerCount);
  }
  return pseudo;
}
